var exports = {
  "kL": "MatureContentChannelGate.module__container___UlN0NW",
  "Qs": "MatureContentChannelGate.module__content___UlN0NW",
  "DD": "MatureContentChannelGate.module__title___UlN0NW",
  "h_": "MatureContentChannelGate.module__description___UlN0NW",
};

module.exports = exports;
